class TopSectionDisplay {
  constructor($rootScope) {
    'ngInject';

    $rootScope.topSectionHidden = false;

    Object.assign(this, { $rootScope });
  }

  hide() {
    this.$rootScope.topSectionHidden = true;
  }

  show() {
    this.$rootScope.topSectionHidden = false;
  }
}

export default TopSectionDisplay;
